import { Swords, Users, Gift } from "lucide-react";
import ScrollReveal from "./ScrollReveal";

const features = [
  {
    icon: Swords,
    title: "Head-to-Head Tipping",
    description:
      "Forget predicting the full grid. Just pick who beats who in 11 driver matchups each week. Simple, fast, and a fresh take on F1 tipping.",
  },
  {
    icon: Users,
    title: "Leagues",
    description:
      "Create a private league, share the invite link, and settle the debate with your mates. Or join a public league and take on fans worldwide.",
  },
  {
    icon: Gift,
    title: "Free Forever",
    description:
      "No subscriptions, no paywalls, no credit card. SEND IT is completely free — now and always.",
  },
];

export default function WhyDifferentSection() {
  return (
    <section className="relative px-6 py-24 sm:py-32">
      <div className="mx-auto max-w-6xl">
        <ScrollReveal>
          <p className="mb-3 text-center text-xs font-semibold uppercase tracking-[0.25em] text-primary">
            Why Send It
          </p>
          <h2 className="mb-16 text-center text-3xl font-black tracking-tight sm:text-4xl">
            Built different.
          </h2>
        </ScrollReveal>

        <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
          {features.map((feature, i) => (
            <ScrollReveal key={i} delay={i * 150} className="h-full">
              <div className="flex h-full flex-col rounded-2xl bg-[hsl(var(--foreground)/0.03)] p-6 sm:p-8">
                <div className="mb-5 flex h-12 w-12 items-center justify-center rounded-xl bg-primary/10">
                  <feature.icon className="h-6 w-6 text-primary" />
                </div>
                <h3 className="mb-3 text-lg font-bold sm:text-xl">
                  {feature.title}
                </h3>
                <p className="text-sm leading-relaxed text-muted-foreground sm:text-base">
                  {feature.description}
                </p>
              </div>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
}
